import React, { FC, useState } from 'react';
import { Button, Carousel, Modal, Space } from 'antd';
import './citations-images.scss';

interface CitationImagesProps {
  photosUrl: string[];
}

export const CitationImages: FC<CitationImagesProps> = ({ photosUrl }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <Button type="link" className="open-citations-btn" onClick={() => setIsOpen(true)} disabled={photosUrl.length === 0}>
        View Images
      </Button>
      <Modal centered title="Citation Images" width={700} open={isOpen} wrapClassName="custom-modal" closable={false} footer={null}>
        <Carousel className="citation-images-wrapper">
          {photosUrl.map((url, index) => (
            <div key={`${url}-${index}`}>
              <img className="citation-image" src={url} alt={`Citation evidence ${index + 1}`} loading="lazy" />
            </div>
          ))}
        </Carousel>
        <Space className="footer">
          <Button type="link" onClick={() => setIsOpen(false)}>
            Close
          </Button>
        </Space>
      </Modal>
    </>
  );
};
